// Free-text search across every visible column.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function SearchBar({ exportBusy, handleExportXlsx, isReviewable, rawVisible, searchText, setAppOffset, setSearchText, setSelected, statusFilter, visibleRows }) {
  return (
    <>
      {/* Free-text search box — works across Pending / Approved / Unmatched. */}
      <div className="card" style={{ padding: '0.5rem 0.75rem', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9em' }}>
        <strong>Search:</strong>
        <input type="text" value={searchText} onChange={e => { setSearchText(e.target.value); setSelected(new Set()); setAppOffset(0); }}
               placeholder="Type to filter — matches plate, customer, site, contractor, driver, truck #, date, time, issue text, raw form fields…"
               style={{ flex: 1, padding: '4px 8px', fontSize: '0.95em' }} />
        {searchText && (
          <button onClick={() => setSearchText('')}
                  style={{ background: '#666', color: '#fff', border: 0, borderRadius: 3, padding: '2px 10px', cursor: 'pointer', fontSize: '0.85em' }}>
            × clear
          </button>
        )}
        <span className="small" style={{ color: '#666', marginLeft: 6 }}>
          {searchText
            ? <>matching <strong>{visibleRows.length}</strong> of {rawVisible.length}{statusFilter !== 'all' && ' (after status filter)'}</>
            : <>{rawVisible.length} total{statusFilter !== 'all' && isReviewable ? ' (' + visibleRows.length + ' after status filter)' : ''}</>}
        </span>
        <button onClick={handleExportXlsx} disabled={exportBusy || visibleRows.length === 0}
                title="Download the currently-filtered rows as an .xlsx file"
                style={{ background: '#0f766e', color: '#fff', border: 0, borderRadius: 3, padding: '4px 10px', cursor: exportBusy ? 'wait' : 'pointer', fontSize: '0.85em', marginLeft: 8 }}>
          {exportBusy ? 'Exporting…' : '⬇ Export to Excel'}
        </button>
      </div>
    </>
  );
}
